export default {
  placeholder: 'Vybrať sústavu jednotiek',
};
